import { jsx } from '@emotion/react';
import { emitUserInteractionEvent } from '../../utils/avroEvents';
import { labelStyles } from '@zapier/style-encapsulation';
import { useClickOutside, ServiceTypeahead } from '@zapier/design-system';
import { useUniversalNavContext } from '../../hooks';
import SearchToggler from './SearchToggler';
import { boxSizing } from '../../../utils/style-mixins/reset';
const Styles = labelStyles('SearchForm', {
    root: ({ isSearching }) => [
        Object.assign(Object.assign({}, boxSizing), { display: 'grid', gridTemplateColumns: '1fr auto', gap: 10, width: isSearching ? '100%' : 'auto', maxWidth: 500 }),
    ],
});
const SearchForm = (props) => {
    const { apiHostname } = useUniversalNavContext();
    const [setClickOutsideNode] = useClickOutside({
        onClickOutside: () => props.onClose(),
    });
    const onEscape = (e) => {
        if (e.key === 'Escape') {
            props.onClose();
        }
    };
    const handleChange = (app) => {
        const { location } = window;
        const isDevOrStaging = location.origin.includes('localhost') ||
            location.origin.includes('zapier-staging');
        const isZapier = location.origin.startsWith('https://zapier.com');
        if (app && app.slug) {
            const url = `/apps/${app.slug}/integrations`;
            emitUserInteractionEvent({
                interaction_name: 'universalNavServiceTypeahead',
                event_action: 'click',
                option_selected: app.slug,
            });
            if (isDevOrStaging || isZapier)
                location.href = `${location.origin}${url}`;
            else
                location.href = `https://zapier.com${url}`;
        }
    };
    return (jsx("div", { css: Styles.root(props), role: "form", "data-zds": true },
        jsx("div", { onKeyUp: onEscape, ref: setClickOutsideNode, "data-zds": true },
            jsx(ServiceTypeahead, { apiHostname: apiHostname, "aria-label": "Search Apps", excludeUpcoming: false, id: "universalNavServiceTypeahead", inputId: props.searchInputId, menuAriaLabel: "List of available apps", onChange: (app) => handleChange(app), placeholder: "Search by App", resultsLimit: 8 })),
        jsx(SearchToggler, { ariaHidden: true, ariaLabel: "Close search", isSearching: true })));
};
export default SearchForm;
//# sourceMappingURL=SearchForm.js.map
// @zapier/universal-layout@11.2.3 (b1a6e8603)
